import { Fragment, useState, useEffect, useContext } from 'react';
import { history } from 'routes';
import api, { endpoints } from 'api';
import Switch from 'components/Switch';
import Navigation from 'components/Navigation';
import { PersonalInfoContext, contextActionTypes } from '../../../contexts';
import { useStepController } from '../../../hooks';
import { useCallback } from 'react';
import { toUsCurrency } from 'lib';

const {
    SELF_ESTIMATE_CORRECT,
    SELF_ESTIMATE_CORRECT_SPOUSE,
} = contextActionTypes;

function EstimateIncome({ spouse }) {
    const [choice, setChoice] = useState(null);
    const [incomeInfo, setIncomeInfo] = useState({});
    const { personalUid, spouseUid, employment, dispatchEmployment } = useContext(
        PersonalInfoContext
    );
    const { nextStep, previousStep } = useStepController();
    const { estimated_average_income, uid, verified } = incomeInfo;
    const {
        clientEmployerName,
        spouseEmployerName
    } = employment;

    useEffect(() => {
        const estimatedIncome = async () => {
            try {
                const req = await api({
                    url: endpoints.SELF_EMPLOYED_AVERAGE_INCOME_ESTIMATION,
                    params: {
                        profile: spouse ? spouseUid : personalUid,
                    },
                });
                const res = await req.data;
                const filterArray = res.find((data) => data.period === 0);
                if (filterArray) {
                    setIncomeInfo(filterArray);
                }
            } catch (e) {
                console.log(e.response);
            }
        };

        if ((spouse && spouseUid) || (!spouse && personalUid)) {
            estimatedIncome();
        }
    }, [personalUid, spouseUid, spouse]);

    const handleEstimateChange = useCallback(
        ({ index }) => {
            dispatchEmployment({
                type: spouse
                    ? SELF_ESTIMATE_CORRECT_SPOUSE
                    : SELF_ESTIMATE_CORRECT,
                payload: index === 0,
            });

            setChoice(index);
        },
        [spouse, dispatchEmployment]
    );

    // To update step context from api response
    useEffect(() => {
        if (typeof verified === 'boolean') {
            handleEstimateChange({
                index: verified ? 0 : 1,
            });
        }
    }, [verified, handleEstimateChange]);

    const saveChoice = async () => {
        try {
            const req = await api({
                method: 'put',
                url: `${endpoints.SELF_EMPLOYED_AVERAGE_INCOME_ESTIMATION}${uid}/`,
                data: {
                    verified: choice === 0 ? true : false,
                },
            });

            const res = await req.data;

            if (res) history.push(nextStep.path);
        } catch (e) {
            console.log(e.response);
        }
    };

    return (
        <Fragment>
            <h1>
                We detected
                <span className="color-blue">
                    {' '}
                    {toUsCurrency(estimated_average_income)}
                </span>
                {' '}
                as your
                {' '}
                {spouse ? <span className="color-blue">spouse's</span> : ''}
                {' '}
                monthly income from
                {' '}
                {spouse ?
                    <span className="color-blue">{spouseEmployerName}.</span>
                    :
                    <span className="color-blue">{clientEmployerName}.</span>
                }
            </h1>
            <p>Is this correct?</p>
            <Switch
                className="my-30"
                onChange={handleEstimateChange}
                choice={choice}
            />
            <Navigation
                disableNext={typeof choice !== 'number'}
                onPrevious={() => history.push(previousStep.path)}
                onNext={saveChoice}
                className="mt-24"
            />
        </Fragment>
    );
}

export default EstimateIncome;
